import "lazysizes/plugins/object-fit/ls.object-fit"
import "lazysizes/plugins/parent-fit/ls.parent-fit"
import "lazysizes/plugins/rias/ls.rias"
import "lazysizes/plugins/bgset/ls.bgset"
import "lazysizes"
import "lazysizes/plugins/respimg/ls.respimg"
import axios from "axios"
import Client from "shopify-buy"

import jQuery, { error } from "jquery"
window.$ = window.jQuery = jQuery
var $nquery = (window.jQuery = jQuery)

import slick from "slick-carousel"
$nquery.fn.slick = $.fn.slick

import { focusHash, bindInPageLinks } from "@shopify/theme-a11y"
function cookiesEnabled() {
  return navigator.cookiesEnabled
}

import Nav from "./scripts/navigation"
import Minicart from "./scripts/sections/minicart"
import Product from "./scripts/sections/product"
import BlogLanding from "./scripts/sections/bloglanding"
import BlogArticle from "./scripts/sections/blogarticle"
import Helpers from "./scripts/helpers"
import PersonalizedReviews from "./scripts/components/personalized-reviews"
import Collection from "./scripts/templates/collection"

// Common a11y fixes
focusHash()
bindInPageLinks()

// Apply a specific class to the html element for browser support of cookies.
if (cookiesEnabled()) {
  document.documentElement.className =
    document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    )
}

$(document).ready(function () {
  Minicart.init()
  Nav.init()
  Product.init()
  BlogLanding.init()
  BlogArticle.init()
  Collection.init()

  document.querySelectorAll(".personalizedReviews").forEach((el) => {
    new PersonalizedReviews(el)
  })
})

// Setup Videos
var playingVideo
$(document).ready(function () {
  //window.addEventListener("resize", checkVideos)
  //checkVideos()

  var videoObs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting === true &&
          !entry.target.classList.contains("loaded")
        ) {
          entry.target.classList.add("loaded")

          entry.target.querySelectorAll("source").forEach((src) => {
            src.setAttribute("src", src.getAttribute("data-src"))
          })

          entry.target.load()
          entry.target.play()
        }
      })
    },
    { threshold: [0] }
  )

  document.querySelectorAll("video").forEach((video) => {
    video.style.display = "block"
    videoObs.observe(video)
  })

  $(".watch-video").click(function () {
    var youtubeID = Helpers.getUrlParam($(this).attr("data-video"), "v")
    var modalId = $(this).attr("data-modal-id")
    var modal
    if (document.querySelector(".modal__video-" + modalId)) {
      modal = $(".modal__video-" + modalId)
    } else {
      modal = $(this).siblings(".modal__video")
    }

    $("body").addClass("fixed")
    $("#overlay").fadeIn(250)
    $(this).closest(".video-vignette__overlay").addClass("playing")

    playingVideo = modal.find("video")[0]
    if (playingVideo) playingVideo.pause()

    modal.fadeIn(250)
    modal.find(".video-container").html(
      `<div class="modal__close">&times;</div>
				<iframe width="560" height="315" src="https://www.youtube.com/embed/` +
        youtubeID +
        `?autoplay=1" frameborder=0 allow="autoplay;" allowfullscreen></iframe>`
    )

    $(".modal__close").click(function (e) {
      $(".modal, #overlay").fadeOut(250)
      $("body").removeClass("fixed")
      $(".video-container").html("")
      $(".video-vignette__overlay").removeClass("playing")
      if (playingVideo) {
        playingVideo.pause()
        playingVideo = null
      }
    })
  })

  $("#overlay").click(function (e) {
    $(".modal, #overlay").fadeOut(250)
    $("body").removeClass("fixed")
    $(".video-container").html("")
    $(".video-vignette__overlay").removeClass("playing")
    if (playingVideo) {
      playingVideo.pause()
      playingVideo = null
    }
  })

  $(".video-vignette__module.banner").each(function () {
    if (
      $(this).index() == 0 &&
      $(this).parent().parent().prop("tagName").toLowerCase() == "main"
    ) {
      $(".header-bar").addClass("transparent")
    }
  })

  $(".video-vignette__module").each(function () {
    if ($(this).attr("data-display-after") != "") {
      var show_after = $(".collection__grid > .product__card").eq(
        parseInt($(this).attr("data-display-after")) - 1
      )
      if (show_after.length > 0) {
        $(this).hide()
        var current_interrupter = $(this).detach()
        show_after.after(current_interrupter)
        current_interrupter.show()
      }
    }
  })
})

// Additional setup
$(document).ready(function () {
  // set up modals
  $("body").on("click", "[data-show-modal]", function (e) {
    if ($(this).attr("data-hide-modal") !== undefined) {
      $("#" + $(this).attr("data-hide-modal")).fadeOut(250)
    }
    var modal = $(this).attr("data-show-modal")
    $("body").addClass("fixed")
    $("#overlay").fadeIn(250)
    $("#" + modal).fadeIn(250)
  })

  // set up modals
  $("body").on("click", "[data-hide-modal]", function (e) {
    if ($(this).attr("data-show-modal") === undefined) {
      $("#overlay, #" + $(this).attr("data-hide-modal")).fadeOut(250)
      $("body").removeClass("fixed")
    }
  })

  // set up scrollto
  $("[data-scroll-to]").click(function (e) {
    e.preventDefault()

    var elements = $(this).attr("data-scroll-to").split(",")
    for (var i in elements) {
      if ($(elements[i]).length > 0) {
        $("html, body").animate(
          {
            scrollTop: $(elements[i]).offset().top,
          },
          750,
          function () {}
        )
        break
      }
    }
  })

  // set up select boxes
  $(".select-container > .selected-item").click(function (e) {
    $(this).closest(".select-container").find(".select-item").toggle()
  })
  $(".select-container > .select-item").click(function (e) {
    $(this)
      .closest(".select-container")
      .find(".selected-item > span")
      .text($(this).text())
    $(this).closest(".select-container").find(".select-item").hide()
  })

  // set up tabs
  $(".tab-container .tab").click(function () {
    $(this).closest(".tab-container").find(".tab-content").hide()
    $(this)
      .closest(".tab-container")
      .find('.tab-content[data-tab="' + $(this).attr("data-tab") + '"]')
      .fadeIn(300)
    $(this).closest(".tab-container").find(".tab").removeClass("active")
    $(this).addClass("active")
  })

  // set up transparent header
  if ($("main > .short-banner:first-child").length > 0) {
    $(".header-bar").addClass("transparent")
    if (
      $("main > .short-banner:first-child .short-banner__content").hasClass(
        "black"
      )
    ) {
      $(".header-bar").addClass("text-black")
    }
  }

  // set up transparent header on page
  if (
    $("body").hasClass("template-page") &&
    $(".page-header").first().hasClass("green-header")
  ) {
    $(".header-bar").addClass("transparent").addClass("green")
  }

  // set up transparent header on page
  if (
    $(".account").length > 0 &&
    $(".account").first().hasClass("pale-header")
  ) {
    $(".header-bar").addClass("transparent").addClass("pale")
  }

  // set up FAQ
  $(".question > p").click(function () {
    $(this).closest(".question").toggleClass("open")
  })

  // set up Show Somethings (ex: values)
  $(".show-something").click(function () {
    if ($(this).hasClass("selected")) {
      if (window.innerWidth < 768) {
        $(this)
          .closest(".show-something-container")
          .find(".show-something")
          .removeClass("selected")
        $(this)
          .closest(".show-something-container")
          .find(".show-something-value")
          .slideUp(300, function () {
            $(this).removeClass("visible")
          })
      }
    } else {
      $(this)
        .closest(".show-something-container")
        .find(".show-something")
        .removeClass("selected")
      $(this).addClass("selected")
      if (window.innerWidth < 768) {
        $(this)
          .closest(".show-something-container")
          .find(".show-something-value")
          .slideUp(300, function () {
            $(this).removeClass("visible")
          })
        $(this)
          .closest(".show-something-container")
          .find(".show-something-value." + $(this).attr("data-show"))
          .slideDown(300, function () {
            $(this).addClass("visible")
          })
      } else {
        $(this)
          .closest(".show-something-container")
          .find(".show-something-value")
          .hide()
          .removeClass("visible")
        $(this)
          .closest(".show-something-container")
          .find(".show-something-value." + $(this).attr("data-show"))
          .fadeIn(300, function () {
            $(this).addClass("visible")
          })
      }
    }
  })

  // set up input labels
  $(".input-label-container").each(function () {
    $(this)
      .find("input")
      .focus(function () {
        $(this).closest(".input-label-container").addClass("valued")
      })
    $(this)
      .find("input")
      .blur(function () {
        if ($(this).val() == "") {
          $(this).closest(".input-label-container").removeClass("valued")
        } else {
          $(this).closest(".input-label-container").addClass("valued")
        }
      })
  })

  // set up login page
  if ($("#recovery-form").length > 0 && window.location.hash == "#recover") {
    $("#recovery-form").show()
    $("#login-form").hide()
    $("#social-login-form").hide()
  }

  // set up article ads
  if ($("body").hasClass("template-article")) {
    var $comments = $("*")
      .contents()
      .filter(function () {
        if (this.nodeType == 8 && this.data.indexOf("adblock") === 0) {
          return true
        } else {
          return false
        }
      })
    $comments.each(function (i, el) {
      console.log(el.data)
      // get the ad data
      var ad_data_raw = el.data
        .replace("/adblock", "")
        .replace("adblock", "")
        .replace(" ", "")
      ad_data_raw = ad_data_raw.slice(1, ad_data_raw.length - 1).split("][")
      var ad_data = { link: "", image: "", vert: "" }
      for (var i = 0; i < ad_data_raw.length; i++) {
        console.log(ad_data_raw[i])
        if (ad_data_raw[i].indexOf("link=") === 0) {
          ad_data["link"] = ad_data_raw[i].slice(6, ad_data_raw[i].length - 1)
        } else if (ad_data_raw[i].indexOf("image=") === 0) {
          ad_data["image"] = ad_data_raw[i].slice(7, ad_data_raw[i].length - 1)
        } else if (ad_data_raw[i].indexOf("vert=") === 0) {
          ad_data["vert"] = ad_data_raw[i].slice(6, ad_data_raw[i].length - 1)
        }
      }

      $(el).replaceWith(
        '<div class="article_ad" style="top:' +
          ad_data["vert"] +
          '"><a href="' +
          ad_data["link"] +
          '"><img src="' +
          ad_data["image"] +
          '" /></a></div>'
      )
      console.log(ad_data)
    })
  }

  // set up slick sliders
  desktopSlider()
  if (window.innerWidth < 768) {
    mobileOnlySlider()
  }

  featuredInSlider()
  klaviyoForm()

  $(window).resize(function (e) {
    if (window.innerWidth < 768) {
      if (!$(".slider").hasClass("slick-initialized")) {
        mobileOnlySlider()
      }
    } else {
      if ($(".slider").hasClass("slick-initialized")) {
        $(".slider").slick("unslick")
      }
    }
  })

  // hacky workaround for stupid slick issue on PDP
  // .slick() is not a function in Product module
  if ($(".product_images").length > 0) {
    setupProductImages()
  }

  // login pages
  if (
    ($(".template-login").length > 0 || $(".template-register").length > 0) &&
    Helpers.getUrlParam(window.location.href, "checkout", false) !== false
  ) {
    $(".checkout-banner").removeClass("hide")
    $('input[name="return_to"]').val("/a/subscription/checkout")
    $(".register_link").attr("href", "/account/register?checkout=true")
    $(".login_link").attr("href", "/account/login?checkout=true")
  }

  // cart to cart functionality
  if ($(".cart-to-cart").length > 0) {
    let products = JSON.parse(
      decodeURI(window.location.href).split("/pages/cart-to-cart?")[1]
    )

    products.forEach((product, index) => {
      setTimeout(() => {
        addProduct(product)
      }, index * 500)
    })

    setTimeout(() => {
      window.location.href = "https://helloned.com/checkout"
    }, products.length * 600)
  }

  // Quickbuy Section
  initQuickbuy()
  ;(async () => {
    const settings = await axios
      .get("/cart?view=checkout")
      .then((response) => response.data)
    const domain = settings.domain
    if (!domain) {
      return
    }

    if (Shopify.shop === domain) {
      return
    }

    const storefront_api_key = settings["storefront_api_key"]
    if (!storefront_api_key) {
      return
    }

    const client = Client.buildClient({
      domain: domain,
      storefrontAccessToken: storefront_api_key,
    })

    $(`[data-checkout]`).on("click", document, (event) => {
      event.preventDefault()
      event.stopImmediatePropagation()
      ;(async (client) => {
        const cart = await axios
          .get("/cart.js")
          .then((response) => response.data)
        const handles = cart.items.map((item) => {
          return item.handle
        })

        const uniqueHandles = Array.from([...new Set(handles)])
        const products = (
          await Promise.all(
            uniqueHandles.map((handle) => {
              return axios.get(`https://${domain}/products/${handle}.js`).then(
                (response) => response.data,
                () => null
              )
            })
          ).then((response) => response)
        )
          .filter((item) => item !== null)
          .reduce((products, product) => {
            return {
              ...products,
              [product.handle]: product,
            }
          }, {})

        const items = cart.items
          .map((item) => {
            const product = products[item.handle]

            if (!product) {
              return null
            }

            const options = item["variant_options"].reduce(
              (options, option, index) => {
                return {
                  ...options,
                  [`option${index + 1}`]: option,
                }
              },
              {}
            )

            const keys = Object.keys(options)

            if (!product.options) {
              return null
            }

            if (keys.length !== product.options.length) {
              return null
            }

            const variant =
              product.variants
                .filter((variant) => {
                  return !keys
                    .map((key) => {
                      return options[key] === variant[key]
                    })
                    .includes(false)
                })
                .shift() || null

            if (!variant) {
              return null
            }

            return {
              variantId: btoa(`gid://shopify/ProductVariant/${variant.id}`),
              quantity: item.quantity,
              customAttributes: Object.keys(item.properties).map((key) => {
                return {
                  key,
                  value: item.properties[key],
                }
              }),
            }
          })
          .filter((item) => {
            return item !== null
          })

        let checkout = await client.checkout.create()
        checkout = await client.checkout.addLineItems(checkout.id, items)
        const userID = await getGoogleClientId()
        const trackingItems = {
          customAttributes: [{ key: "google-clientID", value: userID }],
        }
        checkout = await client.checkout.updateAttributes(
          checkout.id,
          trackingItems
        )

        const webUrl = new URL(`https://${domain}/cart`)
        const params = webUrl.searchParams

        params.set("checkout_id", checkout.id)
        params.set("view", "checkout-loading")
        const search = params.toString()
        webUrl.search = search ? "?" + search : ""

        var redirectUrl = webUrl.toString()

        try {
          redirectUrl = decorateUrl(redirectUrl)
        } catch (e) {
          console.error(e)
        }

        window.location = redirectUrl
      })(client)

      return false
    })
  })()
})

function decorateUrl(url) {
  var gaObject = window[window["GoogleAnalyticsObject"]]

  if (
    typeof gaObject === "function" &&
    typeof window.gaplugins !== "undefined"
  ) {
    var trackers = gaObject.getAll()

    if (trackers.length > 0) {
      var tracker = trackers[0]

      var linker = new window.gaplugins.Linker(tracker)
      url = linker.decorate(url)
    }
  }

  return url
}

function setupProductImages() {
  if (typeof $nquery.fn.slick === "undefined") {
    setTimeout(setupProductImages, 100)
    return false
  }
  Product.setSlick($nquery(".product_images").slick("getSlick"))
}

function desktopSlider() {
  if (typeof $nquery.fn.slick === "undefined") {
    setTimeout(desktopSlider, 100)
    return
  }

  $nquery(".slick").on("init", function (e, slick) {
    if ($(".slick").find(".selected").length > 0) {
      var index = $(".slick")
        .find(".selected")
        .closest(".slick-slide")
        .attr("data-slick-index")
      slick.slickGoTo(index)
    }
  })
  $nquery(".slick").slick({
    dots: true,
    arrows: false,
  })

  // -- PDP Swiper
  if (document.querySelector(".slick--product_images")) {
    let swiperParams = {
      arrows: true,
      dots: true,
      infinite: false,
    }

    if (document.querySelectorAll(".slick--product_imagesThumbs").length) {
      $nquery(".slick--product_imagesThumbs").slick({
        arrows: false,
        asNavFor: ".slick--product_images",
        slidesToShow: 6.35,
        slidesToScroll: 1,
        focusOnSelect: true,
        infinite: false,
      })

      swiperParams["asNavFor"] = ".slick--product_imagesThumbs"
    }

    $nquery(".slick--product_images").slick(swiperParams)
  }
}

function mobileOnlySlider() {
  if (typeof $nquery.fn.slick === "undefined") {
    setTimeout(mobileOnlySlider, 100)
    return false
  }
  $nquery(".mobile-slick").on("init", function (e, slick) {
    if ($(".slick").find(".selected").length > 0) {
      var index = $(".slick")
        .find(".selected")
        .closest(".slick-slide")
        .attr("data-slick-index")
      slick.slickGoTo(index)
    }
  })
  $nquery(".mobile-slick").slick({
    dots: true,
    arrows: false,
  })
}

function featuredInSlider() {
  if (typeof $nquery.fn.slick === "undefined") {
    setTimeout(featuredInSlider, 100)
    return false
  }

  $nquery(".js-partners-slider").on("init", function (e, slick) {
    if ($(".js-slider-featured-in").find(".selected").length > 0) {
      var index = $(".slick")
        .find(".selected")
        .closest(".slick-slide")
        .attr("data-slick-index")
      slick.slickGoTo(index)
    }
  })

  $nquery(".js-partners-slider").slick({
    dots: true,
    arrows: false,
    slidesToShow: 2,
    centerMode: true,
    responsive: [
      {
        breakpoint: 525,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })
}

function klaviyoForm() {
  const $klaviyoForms = $("form[data-klaviyo='true']")

  if (!$klaviyoForms.length) {
    return null
  }

  $klaviyoForms.each(function (index, element) {
    const $klaviyoForm = $(element)

    let $successMessageWrapper = $klaviyoForm.find(".js-message-success")
    let successMessage = $successMessageWrapper.attr("data-success-message")
    let id = $klaviyoForm.attr("id")
    let source = $klaviyoForm.attr("data-source")

    if (!id) {
      return
    }

    let options = {
      custom_success_message: true,
      success_message: successMessage,
    }

    if (source) {
      options = Object.assign(options, {
        extra_properties: {
          $source: source,
        },
      })
    }

    KlaviyoSubscribe.attachToForms("#" + id, options)
  })

  $klaviyoForms.on("submit", (e) => {
    let $target = $(e.currentTarget)
    let $successMessageWrapper = $target.find(".js-message-success")

    const regex =
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

    $target.find("input[data-validate='email']").each((index, element) => {
      let email = $(element).val()

      if (new RegExp(regex).test(email)) {
        $(element).removeClass("input--error")
      } else {
        $(element).addClass("input--error")
        $successMessageWrapper.css("display", "none")
      }
    })
  })
}

function addProduct(product) {
  if (product.flavoue) {
    let subscriptionTime = product.subscriptionPotency == "every-30" ? "0" : "1"

    $.post("/cart/add.js", {
      items: [
        {
          quantity: product.quantity,
          id: product.id,
          properties: {
            _autoskip_periods: subscriptionTime,
            Flavor: product.flavoue,
            _Flavor: product.flavoue,
          },
        },
      ],
    })
  } else if (product.volume) {
    let subscriptionTime = product.subscriptionPotency == "every-30" ? "0" : "1"

    $.post("/cart/add.js", {
      items: [
        {
          quantity: product.quantity,
          id: product.id,
          properties: {
            _autoskip_periods: subscriptionTime,
            Potency: product.volume,
            _Potency: product.volume,
          },
        },
      ],
    })
  } else if (product.subscriptionPotency) {
    let subscriptionTime = product.subscriptionPotency == "every-30" ? "0" : "1"

    $.post("/cart/add.js", {
      items: [
        {
          quantity: product.quantity,
          id: product.id,
          properties: {
            _autoskip_periods: subscriptionTime,
          },
        },
      ],
    })
  } else {
    $.post("/cart/add.js", {
      items: [
        {
          quantity: product.quantity,
          id: product.id,
        },
      ],
    })
  }
}

function getGoogleClientId() {
  return new Promise((resolve) => {
    // gtag only makes 'ga' function available after the library loads
    // so we have to stub it if undefined here
    window.ga =
      window.ga ||
      function () {
        ;(window.ga.q = window.ga.q || []).push(arguments) //eslint-disable-line
      }
    window.ga.l = +new Date()

    const fallback = window.setTimeout(function () {
      //after 4 seconds, assume the script is blocked
      resolve("")
    }, 4000)
    window.ga(function () {
      // this function is called after GA library initializes
      window.clearTimeout(fallback)
      const tracker = window.ga.getAll()[0]
      const clientId = tracker && tracker.get("clientId")

      return resolve(clientId)
    })
  })
}

function checkVideos() {
  $("video").each(function () {
    var ok = false

    if ($(this).hasClass("desktop") && window.innerWidth >= 768) {
      ok = true
    }
    if ($(this).hasClass("mobile") && window.innerWidth <= 767) {
      ok = true
    }

    if (ok) {
      loadVideo($(this))
    }
  })
}

function loadVideo(video) {
  if (video.hasClass("loaded")) return

  var $video = video
  video.addClass("loaded")

  video
    .find("source")
    .each(function () {
      var sourceFile = $(this).attr("data-src")
      $(this).attr("src", sourceFile)
    })
    .promise()
    .done(function () {
      $video[0].load()
      $video[0].play()
      $video.css("display", "block")
      $video.siblings(".video_thumbnail").hide()
    })
}

function initQuickbuy() {
  if (!document.querySelector(".quickbuy")) return

  $(".quickbuy__products").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 736,
        settings: {
          dots: true,
          slidesToShow: 1,
        },
      },
    ],
  })

  document
    .querySelectorAll(".quickbuy .modal.quick-subscribe")
    .forEach((modal) => {
      let price = false
      const freqEl = modal.querySelector(".frequency.selected")
      if (freqEl.querySelector(".flexitem-rc__autodeliver")) {
        price = freqEl.querySelector(".flexitem-rc__autodeliver").innerHTML
      } else if (freqEl.querySelector(".flexitem-flexitem-rc__onetime")) {
        price = freqEl.querySelector(".flexitem-rc__onetime").innerHTML
      }

      if (price) {
        modal.querySelector(".addToCartPrice .price").innerHTML = price
      }
    })
}
